// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"e607c86d","453":"822bd1c5"}[chunkId] + ".chunk.js";
};